import React from 'react'
import linkIcon from './insurancePurchaseIcon.png';
import BottomButton from 'forms/BottomButton';
import Box from 'common/Box';
import Link from 'common/Link';

import css from './InsuranceLink.module.css';

const InsurancePurchaseLink = ({ to }) => {
  return (
    <Box className={css.linkBox}>
      <div className={css.linkIcon}>
        <img src={linkIcon} alt="loader" />
      </div>
      <div className={css.linkTitle}>
        You're almost done!
      </div>
      <div className={css.linkText}>
        Please finish checking out to device protection to your phone. <br />Click the checkout button below to complete your purchase.
      </div>
      <Link className={css.linkBtn} to={to} key={to}>
        <BottomButton>
          Checkout
        </BottomButton>
      </Link>
    </Box>
  )
}

export default InsurancePurchaseLink
